import React from 'react';
import { any, bool, object, number } from 'prop-types';

const ComponentWrapper = ({
	title,
	hideTitle,
	collapseTitle,
	hideBorder,
	children,
	cypressId,
	className,
	titleClass,
}) => {
	let wrapperClass = `component-wrapper`;
	if (hideTitle) wrapperClass += ' component-wrapper--no-title';
	if (hideBorder) wrapperClass += ' component-wrapper--no-border';
	if (collapseTitle) wrapperClass += ' component-wrapper--collapse-title';
	return (
		<div className={wrapperClass}>
			<div className='component-wrapper_title heading60'>
				<span className={`title ${titleClass}`} data-cy={cypressId}>
					{!hideTitle && title}
				</span>
				{/* <div className='notifications'>{Utils.getNotificationIcon(site.module, 6, breakpoint)}</div> */}
			</div>

			<div className={`component-wrapper_content ${className}`}>{children}</div>
		</div>
	);
};

ComponentWrapper.propTypes = {
	title: any,
	hideTitle: bool,
	collapseTitle: bool,
	hideBorder: bool,
	site: object,
	breakpoint: number,
};

ComponentWrapper.defaultProps = {
	title: 'Default Title',
	hideTitle: false,
	collapseTitle: false,
	hideBorder: false,
	site: { module: 'billing' },
	breakpoint: 930,
};

export default ComponentWrapper;
